import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import T, { Translate } from '../../i18n/i18n';
import { getTags, postTag } from '../../../services/tags';

const Container = styled.div`
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${p => p.align ?? 'center'};
    justify-content: flex-start;
`;

const Column = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
`;

const Label = styled.div`
    font-size: 14px;
    color: #999;
    min-width: 70px;
    padding: 0 0 5px 0;

    .variant & {
        margin-top: 20px;
    }
`;

const Subtitle = styled.div`
    font-size: 12px;
    color: #aaa;
    padding: 10px 0 0;
`;

const NoTags = styled.div`
    font-size: 14px;
    color: #888;
    width: 100%;
    height: 38px;
`;

const Loading = styled.div`
    width: 100%;
    height: 50px;
    position: relative;

    &:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -10px 0 0 -10px;
        border: 3px solid transparent;
        border-left: 3px solid #999;
        border-top: 3px solid #999;
        border-radius: 15px;
        box-sizing: border-box;
        width: 20px;
        height: 20px;
        animation: loading forwards infinite 1s linear;
    }
`;

const NoTagsFilter = styled.div`
    font-size: 12px;
    color: #aaa;
    line-height: 18px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 5px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
`;

const BackgroundSelector = styled.div`
    position: fixed;
    top: 0;
    right: 100%;
    bottom: 0;
    left: 0;
    z-index: 9;

    &.opened {
        right: 0;
    }
`;

const SelectorTag = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    position: relative;
`;

const SelectorOptions = styled.div`
    border: 1px solid #999;
    box-shadow: 0 2px 4px rgba(0,0,0,0.3);
    background-color: #222;
    color: #fff;
    position: absolute;
    top: 100%;
    left: -100000px;
    width: 0;
    z-index: -1;
    overflow: hidden;

    &.opened {
        left: 0;
        width: 100%;
        z-index: 10;
        overflow: visible;
    }
`;

const SelectorItem = styled.div`
    width: 100%;
    height: 30px;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 10px;
    box-sizing: border-box;
    color: #fff;
    background-color: transparent;
    transition: all .2s ease 0s;
    cursor: pointer;

    &.selected {
        background-color: #444;
    }

    &.new {
        //padding-left: 30px;
        //position: relative;
        margin-top: 5px;
        box-sizing: border-box;
        border-top: 1px solid #999;
    }

    &.new:before {
        content: '\\F0417';
        //position: absolute;
        //top: 0;
        //left: 0;
        width: 30px;
        height: 30px;
        font-family: 'Material Design Icons';
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: #999;
    }
`;

const Input = styled.input`
    box-sizing: border-box;
    padding: 0 5px;
    background-color: #111;
    color: #fff;
    border: 1px solid #999;
    height: 25px;
    width: 194px;
    min-width: 160px;
    max-width: 200px;
`;

const Select = styled.select`
    box-sizing: border-box;
    padding: 0 5px;
    background-color: #111;
    color: #fff;
    border: 1px solid #999;
    height: 25px;
    width: 70px;
    min-width: 70px;
    max-width: 70px;
    margin-right: 2px;
`;

const TagGroup = styled.div`
    padding: 5px 0;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
`;

const Tag = styled.div`
    height: 33px;
    min-height: 33px;
    font-size: 15px;
    padding: 0 7px;
    color: #fff;
    box-sizing: border-box;
    border: 3px solid ${p => p.color ?? '#fff'};
    border-radius: 15px;
    transition: all .3s ease 0s;
    margin: 0 5px 5px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

export default ({includedColor, avoidedColor, canExclude, canAdd, hideSubtitles, tagGroup, tagService, onChange, onChangeAvoid, value, valueAvoid, ...props}) => {

    const [filter, setFilter] = useState("");
    const [type, setType] = useState("include");
    const [opened, setOpened] = useState(false);
    const [focusItem, setFocusItem] = useState(null);
    const [tagsIncluded, setTagsIncluded] = useState([]);
    const [tagsAvoided, setTagsAvoided] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectorItems, setSelectorItems] = useState([]);

    const timerFilter = useRef(null);
    const inputElement = useRef(null);

    const handleChangeFilter = (e) => {
        if(!opened) {
            setOpened(true);
            setFocusItem(null);
        }

        setFilter(e.target.value);
    }

    const handleChangeType = (e) => {
        setType(e.target.value);
    }

    const handleKeyPress = (e) => {
        if (!opened) {
            return;
        }

        let shouldChnageIndex = 0;

        switch (e.which) {
            case 13: //ENTER
                handleSelecItem(focusItem);
                break;
            case 9: //TAB
            case 27: //ESC
                handleCloseOptions();
                break;
            case 38: //UP
                shouldChnageIndex = -1;
                break;
            case 40: //DOWN
                shouldChnageIndex = 1;
                break;
        }

        if (shouldChnageIndex !== 0) {
            let currentIndex = selectorItems.reduce((acc, cur, i) => (cur.id === focusItem ? i : acc), -1);
            let item = selectorItems && selectorItems.length ? selectorItems[currentIndex + shouldChnageIndex] : null;
            if (item) {
                setFocusItem(item.id);
            } else {
                if (selectorItems && selectorItems.length) {
                    if (shouldChnageIndex < 0) {
                        setFocusItem(selectorItems[selectorItems.length - 1].id);
                    } else {
                        setFocusItem(selectorItems[0].id);
                    }
                }
            }
        }
    }


    const handleRemoveFromIncluded = (id) => {
        let v = tagsIncluded.filter(t => t.id !== id);
        setTagsIncluded(v);
        updateParent(v);
    }

    const handleRemoveFromAvoided = (id) => {
        let v = tagsAvoided.filter(t => t.id !== id);
        setTagsAvoided(v);
        updateParentAvoid(v);
    }

    const handleOpenOptions = () => {
        setFocusItem(null);
        setOpened(true);
    }

    const handleCloseOptions = (e) => {
        setOpened(false);
        setSelectorItems([]);
    }

    const handleSelecItem = async (id) => {
        let item = null;
        if (id === 'NEW') {
            setLoading(true);
            item = await postTag(tagService,filter);
        } else {
            item = selectorItems.filter(i => i.id === id)[0] ?? selectorItems[0];
        }
        
        setLoading(false);
        setOpened(false);
        setFilter("");
        setSelectorItems([]);
        
        if (item !== null) {
            if (type === "avoid") {
                if (!tagsAvoided.some(t => t.id === item.id)) {
                    let v = [...tagsAvoided, item];
                    setTagsAvoided(v);
                    updateParentAvoid(v);
                }
            } else {
                if (!tagsIncluded.some(t => t.id === item.id)) {
                    let v = [...tagsIncluded, item];
                    setTagsIncluded(v);
                    updateParent(v);
                }
            }
        }

        inputElement.current.focus();
    }

    const handleMouseOverItem = (id) => {
        setFocusItem(id);
    }

    useEffect(()=>{
        if (!filter) {
            return;
        }

        let update = true;
        let labelNew = Translate(`filter.${tagGroup}-add`);

        const getData = async () => {
            if (filter){
                setLoading(true);
                let tags = await getTags(tagService, filter);
                if (canAdd) {
                    tags.push({id:"NEW", pt:labelNew, en:labelNew});
                }

                if (update) {
                    setLoading(false);
                    setSelectorItems(tags);
                }
            }
        };

        timerFilter.current = setTimeout(()=>{getData()}, 300);

        return () => {
            update = false;
            clearTimeout(timerFilter.current);
        }
    },[filter, tagService]);

    const updateParent = (newValue) => {
        if (onChange && typeof onChange === 'function') {
            onChange(newValue);
        }
    };

    const updateParentAvoid = (newValue) => {
        if (onChangeAvoid && typeof onChangeAvoid === 'function') {
            onChangeAvoid(newValue);
        }
    };

    useEffect(()=>{
        setTagsIncluded(value);
    }, [value]);

    useEffect(()=>{
        setTagsAvoided(valueAvoid);
    }, [valueAvoid]);
    
    return <Container className={props.className ?? ''}>
        <Column>
            <Label><T value={`filter.${tagGroup}`} /></Label>
            <Row>
                {canExclude ? <Select value={type} onChange={handleChangeType} >
                    <option value="include">{Translate("filter.tagInclude")}</option>
                    <option value="avoid">{Translate("filter.tagAvoid")}</option>
                </Select> : null}
                <SelectorTag>
                    <BackgroundSelector className={opened ? 'opened' : ''} onClick={handleCloseOptions}></BackgroundSelector>
                    <Input 
                        type="text" 
                        value={filter} 
                        onChange={handleChangeFilter} 
                        onKeyDown={handleKeyPress}
                        onFocus={handleOpenOptions}
                        ref={inputElement}
                    />
                    <SelectorOptions className={opened ? 'opened' : ''}>
                        {loading ? <Loading /> : (
                            selectorItems && selectorItems.length ? <>
                                {selectorItems.length === (canAdd ? 1 : 0) ? <NoTagsFilter><T value={`filter.${tagGroup}-notfound`} /></NoTagsFilter> : null}
                                {selectorItems.map(item => <SelectorItem 
                                    key={item.id}
                                    className={(focusItem === item.id ? "selected" : "") + (item.id === "NEW" ? " new" : "")}
                                    onClick={() => handleSelecItem(item.id)}
                                    onMouseOver={() => handleMouseOverItem(item.id)}
                                >{item[Translate("lang")]}</SelectorItem>)}
                            </> : <NoTagsFilter><T value={`filter.${tagGroup}-filter`} /></NoTagsFilter>
                        )}
                    </SelectorOptions>
                </SelectorTag>
            </Row>
        </Column>
        <Row align="flex-start">
            <Column>
                {!hideSubtitles ? <Subtitle><T value={`filter.${tagGroup}-show`} /></Subtitle> : null }
                <TagGroup>
                    {tagsIncluded && tagsIncluded.length ? <>
                        {tagsIncluded.map((tag,i) => <Tag key={i} color={includedColor} onClick={() => handleRemoveFromIncluded(tag.id)}>{tag[Translate("lang")]}</Tag>)}
                    </> : <NoTags><T value={`filter.${tagGroup}-none`} /></NoTags>}
                </TagGroup>
            </Column>
            {canExclude ? <Column>
                {!hideSubtitles ? <Subtitle><T value={`filter.${tagGroup}-hide`} /></Subtitle> : null }
                <TagGroup>
                    {tagsAvoided && tagsAvoided.length ? <>
                        {tagsAvoided.map((tag,i) => <Tag key={i} color={avoidedColor} onClick={() => handleRemoveFromAvoided(tag.id)}>{tag[Translate("lang")]}</Tag>)}
                    </> : <NoTags><T value={`filter.${tagGroup}-none`} /></NoTags>}
                </TagGroup>
            </Column> : null}
        </Row>
    </Container>
}